import AdminTransactionsPage from '../../../components/admin/transactions/AdminTransactionsPage'

export default function Transactions() {
  return <AdminTransactionsPage />
}
